import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
const evidence = [{
  claim: 'Traditional crunches worsen diastasis',
  proof: 'Documented in physical therapy research — abdominal separation worsens under load before closure'
}, {
  claim: 'Calorie restriction spikes cortisol',
  proof: 'Cortisol-fat storage relationship is well-established in endocrinology literature'
}, {
  claim: 'Magnesium improves sleep quality',
  proof: "Multiple peer-reviewed studies confirm magnesium glycinate's effect on sleep architecture"
}, {
  claim: '85% of mothers abandon fitness goals in 90 days',
  proof: 'Consistent finding across postpartum behavioral health research'
}, {
  claim: 'Hypopressive breathing restores core tension',
  proof: 'Used in European physical therapy protocols for 20+ years for postpartum recovery'
}];
export function ProofSection() {
  return <section className="bg-[#81B29A]/10 px-4 py-14 sm:px-6 lg:px-8 lg:py-20" data-id="element-196">
      <div className="mx-auto max-w-4xl" data-id="element-197">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="text-center mb-10" data-id="element-198">
          <h2 className="font-serif text-4xl font-bold text-[#2D2D2D] sm:text-5xl" data-id="element-199">
            The Science Behind the System
          </h2>
        </motion.div>

        <div className="space-y-4 mb-10" data-id="element-200">
          {evidence.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex flex-col sm:flex-row gap-4 rounded-xl bg-white p-6 shadow-sm items-start sm:items-center" data-id="element-201">
              <div className="flex-shrink-0 mt-1 sm:mt-0" data-id="element-202">
                <CheckCircle2Icon className="h-6 w-6 text-[#81B29A]" data-id="element-203" />
              </div>
              <div className="flex-1" data-id="element-204">
                <p className="font-serif text-lg font-bold text-[#2D2D2D]" data-id="element-205">
                  {item.claim}
                </p>
              </div>
              <div className="flex-1 sm:border-l sm:border-gray-200 sm:pl-6" data-id="element-206">
                <p className="font-sans text-sm text-[#2D2D2D]/70" data-id="element-207">
                  {item.proof}
                </p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="mx-auto max-w-3xl text-center" data-id="element-208">
          <p className="font-serif text-3xl italic leading-relaxed text-[#2D2D2D]" data-id="element-209">
            "You don't need more motivation. You need a system that works with
            your biology, not against it."
          </p>
        </motion.div>
      </div>
    </section>;
}